import {
  DrawerFooter as DrawerFooterPrimitive,
  ModalFooterProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

type DrawerFooterProps = ModalFooterProps;

export function DrawerFooter({
  children,
  ...props
}: DrawerFooterProps): ReactNode {
  return (
    <DrawerFooterPrimitive
      borderTopColor="palette_gray.10"
      borderTopStyle="solid"
      borderTopWidth="1px"
      gap="space_unit.x1"
      {...props}
    >
      {children}
    </DrawerFooterPrimitive>
  );
}
